/**
 * Resolves and normalizes the active language to a 2-letter ISO 639-1 code.
 * Follows a 3-tier priority structure: Element attribute -> Global configuration -> DOM/Browser auto-detection.
 *
 * @param {string} [configLanguage] - Explicit language preference (e.g. 'auto', 'en', 'bg')
 * @returns {string} Normalized 2-letter lowercase language code (e.g. 'bg', 'en')
 */
export function resolveLanguage(configLanguage) {
  let lang = configLanguage;

  if (!lang || lang === 'auto') {
    lang = document.documentElement.lang;
  }

  if (!lang || lang === 'auto') {
    lang = navigator.language || (navigator.languages && navigator.languages[0]);
  }

  if (!lang) {
    return 'en';
  }

  return lang.split('-')[0].split('_')[0].toLowerCase().trim();
}
